<template>
  <form v-on:submit.prevent="onSubmit">
    <textarea-length-limitation
      title="Название этапа"
      v-bind:max-length="maxLength"
      v-bind:rows="1"
      v-model="name"
      v-letter-capital
      v-bind:violations="nameInputErrors" />
    <span class="color-stage-modal__text color-stage-modal__text--small">Выберите цвет:</span>
    <color-select
      class="color-stage-modal__select"
      v-bind:color="color"
      v-bind:colors="colors"
      v-on:change-color="onChangeColor"
      v-bind:violations="colorInputErrors"
    />
    <button
      class="color-stage-modal__button"
      type="submit">{{ buttonTitle }}
    </button>
  </form>
</template>

<script>
import ColorSelect from '@/components/ColorSelect.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import { CreationStageRequest } from '@/storage/gateways/CrmGateway';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

/**
 * @description Форма CRM-этапа.
 */
export default {
  components: { ColorSelect, TextareaLengthLimitation },
  computed: {
    nameInputErrors: resolveInputErrors('name'),
    colorInputErrors: resolveInputErrors('color'),
    /**
     * @description Название кнопки формы.
     * @returns {string}
     */
    buttonTitle() {
      return this.initialId !== '' ? 'Сохранить' : 'Создать';
    },
  },
  data() {
    return {
      name: this.initialName,
      color: this.initialColor,
    };
  },
  name: 'FormCrmStage',
  methods: {
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const request = new CreationStageRequest(
        this.name,
        this.color,
        this.funnelId,
        this.initialId,
      );
      this.$emit('submit', request);
    },
    /**
     * @description Обработать изменение цвета.
     * @param {string} color
     */
    onChangeColor(color) {
      this.color = color;
    },
  },
  props: {
    /**
     * @description Идентификатор этапа.
     * @type String
     */
    initialId: {
      default: () => '',
      type: String,
    },
    /**
     * @description Начальное название этапа.
     * @type {String}
     */
    initialName: {
      default: () => '',
      type: String,
    },
    /**
     * @description Максимальная длина.
     * @type {String}
     */
    maxLength: {
      default: () => 150,
      type: Number,
    },
    /**
     * @description Начальный цвет этапа.
     * @type {String}
     */
    initialColor: {
      default: () => '',
      type: String,
    },
    /**
     * @description Идентификатор воронки.
     * @type String
     */
    funnelId: {
      required: true,
      type: String,
    },
    /**
     * @description Цвета.
     * @type {Array}
     */
    colors: {
      required: true,
      type: Array,
    },
    /**
     * @description Ошибки.
     * @type {Object}
     */
    violations: {
      default: () => {},
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.color-stage-modal {
  &__text {
    display: block;
    margin-block: 10px;
    &--small {
      font-size: 12px;
      color: var(--unfocus-color);
    }
  }
  &__select {
    margin-bottom: 20px;
    overflow: auto;
  }
  &__button {
    @include buttons.btn-blue(100%, 3rem, 1rem);
  }
}
.text-stage-modal {
  &__text {
    display: block;
  }
}
</style>
